module.exports = __webpack_public_path__ + "images/search4205e9f17429cd938b3aa139a00cea6b.svg";